import { createSelector } from '@ngrx/store';

import { SHOP_THE_LOOKS_FEATURE_KEY } from '../constants';
import { selectShopTheLookState } from '../main-selector';

import { adapter, ShopTheLooksState } from './shop-the-looks-reducer';

export const selectLookBooksState = createSelector(
  selectShopTheLookState,
  (state) => state[SHOP_THE_LOOKS_FEATURE_KEY],
);

const { selectAll, selectTotal } = adapter.getSelectors(selectLookBooksState);
/**
 * Selector to get all the lookBooks
 */
export const selectLookBooks = selectAll;

/**
 * Selector to get all the lookBooks
 */
export const selectLookBooksLoading = createSelector(
  selectLookBooksState,
  (state: ShopTheLooksState) => state.loading,
);

/**
 * Selector to get all the lookBooks
 */
export const selectLookBooksError = createSelector(
  selectLookBooksState,
  (state: ShopTheLooksState) => state.error,
);

export const selectTotalOfLookBooks = createSelector(
  selectLookBooksState,
  (state: ShopTheLooksState) => state.total,
);

export const selectFullLoaded = createSelector(
  selectTotalOfLookBooks,
  selectTotal,
  (lookBooksTotal: number, totalNumberOfLookBooks: number) => {
    return lookBooksTotal > 0 && lookBooksTotal === totalNumberOfLookBooks;
  },
);

/**
 * Selector to get the page size
 */
export const selectPageSize = createSelector(
  selectLookBooksState,
  (state: ShopTheLooksState) => state.size,
);

/**
 * Selector to get the page number
 */
export const selectPage = createSelector(
  selectLookBooksState,
  (state: ShopTheLooksState) => state.page,
);

/**
 * Selector to get the load lists params
 */
export const selectShopTheLooksParams = createSelector(
  selectPage,
  selectPageSize,
  (page: number, size: number) => {
    return {
      page,
      size,
    };
  },
);
